import * as React from 'react';
import myDnbLogo from '@assets/images/my-dnb-logo.svg';
import mobileMyDnbLogo from '@assets/images/mobile-logo.svg';
import dnbWhiteTextLogo from '@assets/images/dnb-logo-white.svg';
import dnbLogo from '@assets/images/dnblogo.svg';
import mobileDnbLogo from '@assets/images/dnb-ampersand.png';
import { DnbLogoProps } from '@customTypes/PropTypes';

const imageDetails = {
    myDnb: myDnbLogo,
    mobileMyDnb: mobileMyDnbLogo,
    dnbWhiteText: dnbWhiteTextLogo,
    dnb: dnbLogo,
    mobileDnb: mobileDnbLogo,
};

const DnbLogo = ({ logoName, className }: DnbLogoProps) => (
    <>
        <img src={imageDetails?.[logoName]} className={className} alt="logo" />
    </>
);

export default DnbLogo;
